import { Rocket, Radio, Moon } from "lucide-react";

const ROADMAP_BG =
    "https://images.unsplash.com/photo-1457364887197-9150188c107b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxyb2NrZXQlMjBsYXVuY2glMjBuaWdodHxlbnwwfHx8fDE3ODEzNDIzNTd8MA&ixlib=rb-4.1.0&q=85";

const PHASES = [
    {
        id: "blast-off",
        phase: "Phase 01",
        title: "Blast Off",
        desc: "Community building. Onboard the first 10k astronauts. Forge the core crew that will pilot SPACE_100X into orbit.",
        icon: Rocket,
        color: "#00F0FF",
        status: "ACTIVE",
    },
    {
        id: "gravity-assist",
        phase: "Phase 02",
        title: "Gravity Assist",
        desc: "Social media takeover. Memes, threads, alpha groups. Slingshot momentum across X, Telegram and beyond.",
        icon: Radio,
        color: "#B026FF",
        status: "NEXT",
    },
    {
        id: "moon-landing",
        phase: "Phase 03",
        title: "Moon Landing",
        desc: "Raydium listing. Deeper liquidity, listings, partnerships. SPACE_100X plants its flag on the lunar surface.",
        icon: Moon,
        color: "#00F0FF",
        status: "QUEUED",
    },
];

export default function Roadmap() {
    return (
        <section
            id="roadmap"
            data-testid="roadmap-section"
            className="relative py-28 sm:py-36 px-5 sm:px-8 overflow-hidden"
        >
            <div
                aria-hidden
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${ROADMAP_BG})` }}
            />
            <div
                aria-hidden
                className="absolute inset-0 bg-gradient-to-b from-[#030014] via-[#030014]/75 to-[#030014]"
            />
            <div aria-hidden className="absolute inset-0 stars-bg opacity-20" />

            <div className="relative z-10 max-w-7xl mx-auto">
                <div className="mb-20 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
                    <div>
                        <div className="font-mono text-xs tracking-[0.3em] uppercase text-[#00F0FF] mb-4">
                            // MISSION TIMELINE
                        </div>
                        <h2 className="font-display text-3xl sm:text-5xl lg:text-6xl font-black tracking-tighter uppercase text-white">
                            Trajectory to
                            <br />
                            <span className="gradient-text">lunar velocity</span>
                        </h2>
                    </div>
                    <p className="max-w-md font-mono text-sm text-slate-400 leading-relaxed">
                        Three phases. One destination. Every milestone is
                        community-driven and transparent on-chain.
                    </p>
                </div>

                {/* Timeline */}
                <div className="relative">
                    {/* Connector line for desktop */}
                    <div
                        aria-hidden
                        className="hidden md:block absolute top-12 left-[8%] right-[8%] h-px bg-gradient-to-r from-transparent via-[#00F0FF]/40 to-transparent"
                    />

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-10">
                        {PHASES.map((p, idx) => {
                            const Icon = p.icon;
                            return (
                                <div
                                    key={p.id}
                                    data-testid={`roadmap-phase-${p.id}`}
                                    className="relative"
                                >
                                    {/* Node */}
                                    <div className="flex flex-col items-center md:items-start">
                                        <div
                                            className="relative w-24 h-24 rounded-full flex items-center justify-center mb-6"
                                            style={{
                                                background: `radial-gradient(circle, ${p.color}33 0%, transparent 70%)`,
                                            }}
                                        >
                                            <div
                                                className="w-16 h-16 rounded-full bg-[#0B0B1A] border-2 flex items-center justify-center"
                                                style={{
                                                    borderColor: p.color,
                                                    boxShadow: `0 0 28px ${p.color}55`,
                                                }}
                                            >
                                                <Icon
                                                    size={24}
                                                    style={{ color: p.color }}
                                                />
                                            </div>
                                            <div
                                                className="absolute -top-1 -right-1 px-2 py-0.5 rounded-full font-mono text-[9px] tracking-[0.2em] uppercase border bg-black/80"
                                                style={{
                                                    borderColor: `${p.color}66`,
                                                    color: p.color,
                                                }}
                                            >
                                                {p.status}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Card */}
                                    <article
                                        className={`card-hover bg-[#0B0B1A] border border-white/10 rounded-2xl p-7 ${
                                            idx === 1 ? "md:-mt-2" : ""
                                        }`}
                                    >
                                        <div
                                            className="font-mono text-[10px] tracking-[0.3em] uppercase mb-2"
                                            style={{ color: p.color }}
                                        >
                                            {p.phase}
                                        </div>
                                        <h3 className="font-display text-2xl sm:text-3xl font-black uppercase tracking-tight text-white">
                                            {p.title}
                                        </h3>
                                        <p className="font-mono text-sm text-slate-400 leading-relaxed mt-4">
                                            {p.desc}
                                        </p>
                                    </article>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
}
